import { useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { routesHandler } from 'Checkout/Routes/routesHandler'
import useWindowDimensions from 'Shared/Hooks/useWindowDimensions'
import ContinuePaymentButton from 'Checkout/Components/Shared/ReservationDetails/ContinuePaymentButton'
import CampgroundImage from './CampgroundImage'
import CartSummary from 'Checkout/Components/Shared/CartSummary'
import PaymentButton from 'Checkout/Components/Payment/PaymentButton'
import ViewButtons from 'Checkout/Components/Shared/ViewButtons/ViewButtons'
import './ReservationDetails.scss'

const ReservationDetails = () => {
  const { isDesktopView } = useWindowDimensions()
  const location = useLocation()
  const isCartPage = routesHandler.cart.path === location.pathname
  const isPaymentPage = routesHandler.payment.path === location.pathname
  const nonRefundableAmount = useSelector(state => (state.cart.pricing.data?.totalNonRefundableAmount))

  return (
    <div className="reservation-details position-relative h-100">
      {!isCartPage && <CampgroundImage />}

      <div className="sticky-top">
        <div>
          {!isCartPage && isDesktopView && <ViewButtons />}

          <div className="details p-4 mb-5">
            {isPaymentPage && (
              <PaymentButton classButton="w-100" />
            )}

            <CartSummary />

            {isCartPage && <ContinuePaymentButton />}

            {nonRefundableAmount?.amount > 0 && (
              <>
                <hr />

                <small className="text-muted fst-italic">
                  <span className="fw-bold pe-1">{nonRefundableAmount?.display}</span>
                  of this reservation is non-refundable per the RoverPass
                  Cancellation policy. Check the campground cancellation policy for any other non-refundable
                  amounts.
                </small>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ReservationDetails
